import Vue from 'vue'
import Vuex from 'vuex'
import devMode from '@/devMode.js'
import fakeData from '@/dev/fakeData.js'
import logScope from 'log-scope'
import adminStore from './adminStore.js'
import landingStore from './landingStore.js'
import checkoutStore from './checkoutStore.js'

Vue.use(Vuex)

const log = logScope('store')
log.success('Initializing...')

const store = new Vuex.Store({
  modules: {
    adminStore,
    landingStore,
    checkoutStore
  }
})

// Development
window.store = store
if (devMode.useFakeData === true) {
  log.danger('Using fake data')
  fakeData.init(store)
}

export default store
